import { CATEGORY_LABELS } from '@/constants/products'
import type { ProductCategory } from '@/schemas/product.schema'

export interface ProductPlaceholderModelProps {
  name: string
  category: ProductCategory
}

function resolveInitial(name: string): string {
  const [firstCharacter] = Array.from(name)
  return firstCharacter ? firstCharacter.toLocaleUpperCase('pt-BR') : ''
}

export function useProductPlaceholderModel({
  name,
  category,
}: ProductPlaceholderModelProps) {
  return {
    name,
    initial: resolveInitial(name),
    ariaLabel: `${name}, categoria ${CATEGORY_LABELS[category]}`,
  }
}
